import { EMAIL_RE } from '../regexes';
import { TLD_SET } from '../tlds';

export function validateEmail(value) {
    if (typeof value !== 'string') {
        return false;
    }
    if (!EMAIL_RE.test(value)) {
        return false;
    }
    return !!TLD_SET[value.substring(value.lastIndexOf('.') + 1).toLowerCase()];
}
